module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAgCAYAAAABtRhCAAAAAXNSR0IArs4c6QAAAVhJREFUSEtjZICC////M/ZNnJzC+P9/MgMDo/b///95YHLk0IyMjF8YGP5f/c/IOLcoP3cOIyPjf5A5jCCiv3+m5H+Gn0v+///vRI7hhPQwMjLuY2RgjyksTH/OCPJZ/4TJe2hlGcwxIEsLC3JdGHsnTEpl+Pd/FiFXUkWeiTGNsa9/4on//xnMqWIgAUMYGRlOMvb1T/pMaQIh1rGghMTY2zcRnHrQQVFhHlZz+vonEWs+VnUUWaivp4vV0IuXLuN0FEUWkhMKQ8vC0NAgrEG3evU62gQpOakHZ5CqqapgNe/W7Tvk2APXg9NCikzFo3nwWGhpQX5pd/zESeolGmKCGl9pRHI+pJmFPt6exJiNVc2WrdtJD1KybSNUReGqLehuoZCQENl2vnv3jvQgxVUTEOOKoZFK6e5DYoKOHDX0b0TRvZlI94Yw3Zv6oIina2cGltLo1V0DAJ0h4NGOTBVJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/learnmodel/article1.png
// module id = RQi4
// module chunks = 96